import PropTypes from "prop-types";
import { useField } from "formik";
import { Input } from "./Input";

export const FormikInput = ({ name, errorTransform, ...props }) => {
  const [field, meta] = useField(name);
  const rawError = meta.touched && meta.error ? meta.error : undefined;
  const error = errorTransform ? errorTransform(rawError) : rawError;
  return <Input {...field} {...props} error={error} />;
};

FormikInput.propTypes = {
  name: PropTypes.string.isRequired,
  errorTransform: PropTypes.func,
};
